import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { OscReferenceAppCommonModule } from 'osc-reference-app-common';
import { LayoutModule } from '@angular/cdk/layout';
import { SelectionFieldComponent } from '@shared/components';
import { OscUtilsModule } from '@osc-utils/osc-utils.module';
import { FileListModule } from '../file-list/file-list.module';
import { WebReportModule } from '../web-report/web-report.module';
import { PinchZoomComponent } from '../pinch-zoom/pinch-zoom.component';
import { components } from './components';
import { materialModules } from './material';

@NgModule({
  imports: [
    CommonModule,
    DragDropModule,
    FileListModule,
    FormsModule,
    LayoutModule,
    ...materialModules,
    WebReportModule,
    ReactiveFormsModule,
    OscUtilsModule,
    OscReferenceAppCommonModule,
    SharedModule,
    SelectionFieldComponent,
    PinchZoomComponent,
    ...components,
  ],
  exports: [...components],
})
export class InteractiveIsometricSharedModule {}
